export default {
  notificationsForSys: [],
  infoDB: {},
  countUnreadNotificationsForSys:'',
}
